export { default as Icons, IconsProps } from "./Icons.component";